import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox_normal",
  "use": "icon-checkbox_normal-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkbox_normal\"><path d=\"m8 .5c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5-7.5-3.358-7.5-7.5 3.358-7.5 7.5-7.5z\" fill=\"none\" stroke=\"#969799\" /><path d=\"m8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z\" fill=\"#00b279\" /><path d=\"m5.95 11.51-2.828-2.829c-.188-.187-.293-.442-.293-.707s.105-.52.293-.707c.188-.188.442-.293.707-.293s.52.105.707.293l2.121 2.121 4.261-4.261c.188-.188.442-.293.707-.293s.52.105.707.293.293.442.293.707-.105.52-.293.707l-4.968 4.969c-.188.188-.442.293-.707.293s-.519-.106-.707-.293z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/checkbox_normal.svg
// module id = Vd9+
// module chunks = 87